import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSquareInfo = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M20.25 3.75H21V3H20.25V3.75ZM20.25 20.25V21H21V20.25H20.25ZM3.75 20.25H3V21H3.75V20.25ZM3.75 3.75V3H3V3.75H3.75ZM10.75 10.25H10V11.75H10.75V10.25ZM12 11L12.75 11L12.75 10.25H12V11ZM11.25 16.25L11.25 17L12.75 17L12.75 16.25L11.25 16.25ZM19.5 3.75V20.25H21V3.75H19.5ZM20.25 19.5H3.75V21H20.25V19.5ZM4.5 20.25V3.75H3V20.25H4.5ZM3.75 4.5H20.25V3H3.75V4.5ZM10.75 11.75H12V10.25H10.75V11.75ZM11.25 11L11.25 16.25L12.75 16.25L12.75 11L11.25 11Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5 7.375H11.375V7.5V8.5V8.625H11.5H12.5H12.625V8.5V7.5V7.375H12.5H11.5Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: .25
		})
	]
});
export default SvgSquareInfo;
